@if(error) {
  <div class="alert alert-danger">{{error}}</div>
}
<div class="container">
  <div class="row">
    <div class="span9">
      <h1> Request Event</h1>
    </div>
    <p class="lead">
      Send an oadrPoll request to a 2.0b VTN or an oadrRequestEvent request to a 2.0a VTN, both resulting in picking up new events from the VTN.
      Generally this is run on a schedule specified by the VEN/VTN registration.
      VENs must have certs attached and be associated with a VTN in order to perform this action. 2.0b VENs should also have a registration created.
    </p>
  </div>
  @if(isLoading) {
    <app-loader
      message="Loading...">
    </app-loader>
  } @else {
    <form name="requestForm" class="form-horizontal">
      <div class="form-group">
        <label for="venId"> Ven Id (format: [name] : [id]): </label>
        <select id="venId" class="form-control" name="ven_id" type="select" required (change)="getVen($event.target)">
          <option selected disabled value=""></option>
          @for(ven of vens; track ven) {
            <option [value]="ven.id">{{ven?.name}} : {{(ven?.id)}}{{ven?.paused ? " : (PAUSED)" : null}}</option>
          }
        </select>
      </div>

      <button id="performAction" class="btn btn-primary" type="button" (click)="performAction()">Perform action</button>
    </form>
    <h5> Request Results</h5>
    <blockquote class="blockquote">
      <p class="mb-0">{{result}}</p>
    </blockquote>
  }
</div>
